// Joins class names, skipping falsy values. A Tailwind-free stand-in for shadcn's cn().
export const cn = (...classes: (string | false | null | undefined)[]) => classes.filter(Boolean).join(' ')
